import { Table, TableContainer, Tbody, Td, Thead, Tr } from '@chakra-ui/table';
import { useContasReceber } from '../contexts/ContasReceberProvider';
import { ThUsage } from './ThUsage';
import { Suspense, lazy, useEffect, useState, useRef } from 'react';
import { Loader } from '../../../../components/ComponentLoader/Loader';
import { Center, Text, Tooltip } from '@chakra-ui/react';
import { useFilterDataOderBy } from '../../../../hooks/useFilterDataOderBy';
import { format } from 'date-fns';
import { formatPrice } from '../../../../utils/formatPrice';
import { Badge, Flex } from '@chakra-ui/layout';
import { Pagination } from '../components/Pagination';

const loadingImg = '../../../../../images/loading-blue.gif';

const TrUsage = lazy(() => import('./TrUsage'));

export function TableContasReceber() {
  const { data, page, setPage, lastPage } = useContasReceber();

  const statusText = (status) => {
    const label = {
      N: 'Pago',
      S: 'Pendente',
      A: 'Atrasado',
      R: 'A receber'
    };

    return label[status];
  };

  const statusColor = (status) => {
    const options = {
      N: 'green.500',
      S: 'yellow.500',
      A: 'red.500',
      R: 'blue.500'
    };

    return options[status];
  };

  const { filteredData, newerOrOlder, setNewerOrOlder } = useFilterDataOderBy(
    data,
    'data_vencimento'
  );


  return (
    <>
      <Flex
        w={'100%'}
        alignItems="center"
        justifyContent="flex-end"
        paddingRight={'1rem'}
        paddingBottom={'.5rem'}>
        <Text>
          {' '}
          Você está na página: {page} de {lastPage} páginas
        </Text>
      </Flex>
      <TableContainer textAlign="center" overflowY="auto" overflow="auto">
        <Table variant="striped" colorScheme="gray" fontSize="0.7rem">
          <Thead textAlign="center" px="6rem" position="sticky" top="0" zIndex="0">
            <Tr bg="#378BBF" color="white" mx="6rem">
              <ThUsage text="EMPRESA" />
              <ThUsage text="Razão social" />
              <ThUsage text="Emissão NFE" />
              <ThUsage text="NRO PEDIDO" />
              <ThUsage
                text="VENCIMENTO"
                setNewerOrOlder={setNewerOrOlder}
                newerOrOlder={newerOrOlder}
              />
              <ThUsage text="BAIXA" />
              <ThUsage text="PGTO" />
              <ThUsage text="NRO NFE" />
              <ThUsage text="VLR PEDIDO" />
              <ThUsage text="VLR PAGO" />
              <ThUsage text="ATRASO" />
              {/* <ThUsage text="OBS OP" /> */}
              <ThUsage text="PAGARME" />
              <ThUsage text="TIPO PGTO" />
              <ThUsage text="USUÁRIO BAIXA" />
              <ThUsage text="STATUS" />
              <ThUsage text="HISTÓRICO" />
            </Tr>
          </Thead>

          <Tbody>
            <Suspense fallback={<Loader img={loadingImg} />}>
              {data.map((dataItem) => (
                <Tr
                  key={dataItem.id}
                  id={dataItem === data[data.length - 1] ? 'last-row' : ''}
                  // id={dataItem === data[data.length - 1] ? "last-row" : ""}
                >
                  <Td textAlign="center">{dataItem.empresa}</Td>
                  <Td textAlign="center">
                    <Tooltip label={dataItem.razao_social}>
                      {dataItem.razao_social.length > 15
                        ? dataItem.razao_social.slice(0, 15) + '...'
                        : dataItem.razao_social}
                    </Tooltip>
                  </Td>

                  <Td textAlign="center">
                    {dataItem.data_pedido
                      ? format(new Date(dataItem.data_pedido), 'dd/MM/yyyy HH:mm')
                      : ''}
                  </Td>
                  <Td textAlign="center">{dataItem.numero_pedido}</Td>
                  <Td textAlign="center">
                    {format(new Date(dataItem.data_vencimento), 'dd/MM/yyyy')}
                  </Td>
                  <Td textAlign="center">
                    {dataItem.data_baixa
                      ? format(new Date(dataItem.data_baixa), 'dd/MM/yyyy HH:mm')
                      : ''}
                  </Td>
                  <Td textAlign="center">
                    {dataItem.data_pagamento
                      ? format(new Date(dataItem.data_pagamento), 'dd/MM/yyyy HH:mm')
                      : ''}
                  </Td>
                  <Td textAlign="center">{dataItem.numero_nfe}</Td>
                  <Td textAlign="center">
                    {dataItem.valor_pedido ? formatPrice(dataItem.valor_pedido) : ''}
                  </Td>

                  <Td textAlign="center">{formatPrice(dataItem.valor_pago)}</Td>

                  <Td textAlign="center">
                    <Text color="red.500">{dataItem.dias_atraso}</Text>
                  </Td>
                  {/* <Td textAlign="center">
                    <Tooltip
                      label={dataItem.observacao}
                    >
                      <Text color={dataItem.observacao === '' ? 'red.500' : 'blue.500'}>
                        {dataItem.observacao !== '' ? dataItem.observacao.substring(0, 20) + "..." : "Não tem"}
                      </Text>
                    </Tooltip>
                  </Td> */}
                  <Td textAlign="center">{dataItem.codigo_pagarme}</Td>

                  <Td textAlign="center">{dataItem.tipo_pagamento}</Td>
                  <Td textAlign="center">{dataItem.usuario_baixa}</Td>
                  <Td textAlign="center" color={statusColor(dataItem.pendente)}>
                    <Badge colorScheme={statusColor(dataItem.pendente)} fontSize="0.66rem">
                      {statusText(dataItem.pendente)}
                    </Badge>
                  </Td>
                  <Td textAlign="center" cursor="pointer">
                    <Tooltip label={dataItem.historico} fontSize="0.66rem" color="white">
                      {dataItem.historico !== ''
                        ? dataItem.historico.substring(0, 20) + '...'
                        : 'Não tem'}
                    </Tooltip>
                  </Td>
                </Tr>
              ))}
            </Suspense>
          </Tbody>
        </Table>
        {data?.length === 0 && (
          <Center w="100%" mt="2rem">
            <Text
              fontSize="1.5rem"
              fontWeight="bold"
              textTransform="uppercase"
              letterSpacing=".6px"
              color="gray.500">
              Nenhum registro encontrado
            </Text>
          </Center>
        )}
      </TableContainer>
      <Center marginBlock={'1rem'}>
        <Pagination />
      </Center>
    </>
  );
}
